export default "__VITE_ASSET__q986JcVh__"